import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import PropTypes from "prop-types";

import useCurrentUser from "data/advisor/useCurrentUser";
import useHub from "data/hub/useHub";

import ManageHouseholdModal from "components/ManageHouseholdModal";
import ReminderRescheduleModal from "components/ReminderRescheduleModal";
import StreamModal from "components/StreamModal";
import TagModal from "components/TagModal";
import ViewModal from "components/ViewModal";

import { OpenConnectCrmModal } from "scenes/Hubly/components/HubModals/components/ConnectCRMModal/actions";
import ChangePlanModal from "scenes/Settings/components/AccountSettings/components/ChangePlanModal";
import { AddUserModal } from "scenes/Settings/components/HubSettings/components/UserInformationForm/components";
import { CloseAddUserModal } from "scenes/Settings/components/HubSettings/components/UserInformationForm/components/AddUserModal/action";

import { ModalTypes, useModalLauncherFromSearchParam } from "./hooks";
import useGetHouseholdRoles from "./hooks/useHouseholdRoles";
import ExportAuditTrail from "./components/ClientCard/components/CardWorkflows/components/ExportAuditTrail";
import CommentFilterContextDataProvider from "./components/ClientCard/components/CommentFilter/CommentFilterContextDataProvider";
import { useWorkDesk } from "../Workspace/components/hooks";
import { ClientCardModal, ConnectCRMModal } from "./components";

function HubModals({
  auditOpen,
  createHouseholdModalOpen,
  householdId,
  match,
  reminder,
  reminderRescheduleModalOpen,
  stream,
  tag,
  viewModalOpen,
  isConnectCrmModalOpen,
  isChangePlanModalOpened,
  coupon,
  isAddUserModalOpened,
  addUserModalProps,
}) {
  const { isWorkdeskClientPath } = useWorkDesk();
  const { clientId, workflowId } = match.params;
  const showClientCardModal = Boolean(clientId) || isWorkdeskClientPath;
  const { data } = useGetHouseholdRoles();
  const user = useCurrentUser();
  const hub = useHub();
  const dispatch = useDispatch();
  const { modal, modalParams, closeModal } = useModalLauncherFromSearchParam();

  useEffect(() => {
    if (user?.connectCrm && hub?.clientPool?.type && !isConnectCrmModalOpen) {
      if (hub?.clientPool?.type !== "hubly")
        dispatch(OpenConnectCrmModal(hub.clientPool.type));
    }
  }, [user, hub, dispatch, isConnectCrmModalOpen]);

  return (
    <React.Fragment>
      {isConnectCrmModalOpen && <ConnectCRMModal />}

      {(modal === ModalTypes.CHANGE_PLAN || isChangePlanModalOpened) && (
        <ChangePlanModal
          coupon={modalParams?.coupon || coupon}
          onClose={closeModal}
        />
      )}

      {showClientCardModal && (
        <CommentFilterContextDataProvider>
          <ClientCardModal
            clientId={clientId}
            workflowId={workflowId}
            householdRoles={data}
          />
        </CommentFilterContextDataProvider>
      )}

      {isAddUserModalOpened && (
        <AddUserModal
          onSubmitCb={() => {
            dispatch(CloseAddUserModal());
          }}
          onClose={() => {
            dispatch(CloseAddUserModal());
          }}
          {...addUserModalProps}
        />
      )}

      {createHouseholdModalOpen && (
        <ManageHouseholdModal
          clientId={clientId}
          householdId={householdId}
          householdRoles={data}
        />
      )}
      {auditOpen && <ExportAuditTrail clientId={clientId} />}
      {reminderRescheduleModalOpen && (
        <ReminderRescheduleModal reminder={reminder} />
      )}
      {stream && stream.id && <StreamModal />}
      {tag && tag.id && <TagModal />}
      {viewModalOpen && <ViewModal />}
    </React.Fragment>
  );
}

HubModals.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.object.isRequired,
    path: PropTypes.string.isRequired,
  }).isRequired,
  auditOpen: PropTypes.bool,
  createHouseholdModalOpen: PropTypes.bool,
  householdId: PropTypes.string,
  reminder: PropTypes.shape({
    time: PropTypes.string,
    taskId: PropTypes.string,
    title: PropTypes.string,
    id: PropTypes.string,
  }),
  reminderRescheduleModalOpen: PropTypes.bool,
  stream: PropTypes.object,
  tag: PropTypes.object,
  viewModalOpen: PropTypes.bool,
  isConnectCrmModalOpen: PropTypes.bool,
  isChangePlanModalOpened: PropTypes.bool,
  coupon: PropTypes.string,
  isAddUserModalOpened: PropTypes.bool,
  addUserModalProps: PropTypes.object,
};

HubModals.defaultProps = {
  auditOpen: false,
  createHouseholdModalOpen: false,
  householdId: "",
  reminder: {},
  reminderRescheduleModalOpen: false,
  stream: {},
  tag: {},
  viewModalOpen: false,
  isConnectCrmModalOpen: false,
  isChangePlanModalOpened: false,
  coupon: null,
  isAddUserModalOpened: false,
  addUserModalProps: {},
};

const mapStateToProps = (state, _) => {
  return {
    advisor: state.hubly.data.advisor,
    auditOpen: state.hubly.scenes.hubly.hubModals.audit.auditOpen,
    createHouseholdModalOpen:
      state.hubly.createHousehold.createHouseholdModalOpen,
    householdId: state.hubly.createHousehold.householdId,
    reminder: state.hubly.reminderReschedule.reminder,
    reminderRescheduleModalOpen:
      state.hubly.reminderReschedule.reminderRescheduleModalOpen,
    stream: state.hubly.streams.stream,
    tag: state.hubly.tags.tag,
    viewModalOpen: state.hubly.viewModal.viewModalOpen,
    isConnectCrmModalOpen: state.hubly.connectCrmModal.isConnectCrmModalOpen,
    isChangePlanModalOpened:
      state.hubly.changePlanModal.isChangePlanModalOpened,
    coupon: state.hubly.changePlanModal.coupon,
    isAddUserModalOpened: state.hubly.addUserModal.isAddUserModalOpened,
    addUserModalProps: state.hubly.addUserModal.addUserModalProps,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(HubModals);
